import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'

const Fees = () => {
  return (
    <div>
      <Container>
        <h3 className='mt-5 mb-5'>Fees Structure</h3>
        <Row className='d-flex justify-content-center mb-5'>
          <h3 className='mb-5'>For Academic Year 2025-26</h3>
          <Col md={8}>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Class</th>
                  <th>Fees(₹)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Nursery to UKG</td>
                  <td>800</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>I & II</td>
                  <td>850</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>III & IV</td>
                  <td>1000</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>V</td>
                  <td>1050</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>VI</td>
                  <td>1100</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>VII & VII</td>
                  <td>1200</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>IX</td>
                  <td>1700</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>X</td>
                  <td>1800</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>XI</td>
                  <td>2000</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>XII</td>
                  <td>2100</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row className='mb-5'>
          <h3 className='mb-2'>Note:</h3>
          <Col md={8} >
            <ul>
              <li><b>Registration Fee:</b> Rs. 300.00(Per New Student from NUR to VIII) & Rs 500.00 (For IX to XII)</li>
              <li><b>Admission Fee:</b> Rs. 2000.00(Per New Student for NUR-VIII)</li>
              <li><b>Admission Fee:</b> Rs. 2500.00(Per New Student for IX & XI)</li>
              <li><b>Note:</b> Exam Fee is deposited in the month of August & December in every academic session
              along with monthly composite fee.</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Fees